<template>
	<report-page
		ref="page"
		:start-date="true"
		:end-date="true"
		get-url="/bo/report/finance/transactions"
		title="Transactions Report"
		export-filename="transactions"
		:show="false"
	/>
</template>

<script>
import ReportPage from '../../../../../organisms/ReportPage.vue';

export default {
	name: 'TransactionsReport',
	components: {
		ReportPage
	}
};
</script>
